import { useEffect, useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

const UserAlert = ({ bookingData }) => {
  const [open, setOpen] = useState(true);

  useEffect(() => {
    // Auto close after 30 seconds
    const timer = setTimeout(() => {
      setOpen(false);
    }, 30000);

    return () => clearTimeout(timer);
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogContent>
        <Typography
          variant="body1"
          sx={{ textAlign: 'center' }}
          component={'p'}
        >
          Thank you for your booking. You will receive an email from{' '}
          <b>
            {['ALN', 'AUH'].includes(bookingData.OutDetails.StateCode)
              ? 'adrez@thriftyuae.ae'
              : 'rez@thriftyuae.ae'}
          </b>{' '}
          requesting the required documents. Please share the documents
          promptly, as they are mandatory to initiate the booking fulfilment
          process.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ justifyContent: 'center' }}>
        <Button
          variant="contained"
          sx={{ borderRadius: 5, width: 100 }}
          onClick={handleClose}
        >
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default UserAlert;
